"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DatePickerPropTypes = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactI18next = require("react-i18next");
var _cnbuilder = require("cnbuilder");
var _uuid = require("uuid");
var _calendarDefault = _interopRequireDefault(require("@teladoc/pulse/icons/calendar-default.svg"));
var _lockDefault = _interopRequireDefault(require("@teladoc/pulse/icons/lock-default.svg"));
var _useOnClickOutside = _interopRequireDefault(require("@livongo/utilities/hooks/useOnClickOutside"));
var _environment = _interopRequireDefault(require("@livongo/utilities/system/environment"));
var _DateTime = require("../Context/l10n/DateTime");
var _Calendar = _interopRequireWildcard(require("../Calendar"));
var _FormElementError = _interopRequireDefault(require("../FormElementError"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _TextInput = _interopRequireDefault(require("../TextInput"));
var _Button = _interopRequireDefault(require("../Button"));
var _DatePickerModule = _interopRequireDefault(require("./DatePicker.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["navigationType"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const CALENDAR_DEFAULTS = {
  navigationType: 'arrows',
  disablePast: false,
  overrideInitialMonthWithSelected: true
};
const SUBMIT_FORMAT = 'MM/dd/yyyy';
const DATE_FORMAT_PARTS = {
  day: 'dd',
  month: 'MM',
  year: 'yyyy'
};
function pad(num) {
  return num < 10 ? "0".concat(parseInt(num, 10)) : "".concat(num);
}
function calculateCalendarY(ref) {
  const input = ref.querySelector('input');
  const control = input.parentNode.parentNode;
  return "".concat(control.offsetTop + input.offsetHeight + 12, "px");
}
function getInfo(_ref) {
  let {
    t,
    DateTimeFormat,
    date
  } = _ref;
  const parts = DateTimeFormat().formatToParts(date ? new Date(date) : new Date());
  const literal = parts.find(item => item.type === 'literal').value;
  let displayValue = '';
  let dateFormat = '';
  let mask = '';
  let displayMask = '';
  let pattern = '';
  parts.forEach(_ref2 => {
    let {
      type,
      value
    } = _ref2;
    if (type !== 'literal') {
      dateFormat += DATE_FORMAT_PARTS[type];
      mask += type === 'year' ? '9999' : '99';
      displayMask += t("ui:datePicker.".concat(type));
      pattern += "[0-9]{".concat(pad(value).length, "}");
      if (date) {
        displayValue += pad(value);
      }
    } else {
      dateFormat += literal;
      mask += literal;
      displayMask += literal;
      pattern += literal;
      if (date) {
        displayValue += literal;
      }
    }
  });
  return {
    literal,
    displayValue,
    dateFormat,
    mask,
    displayMask,
    pattern
  };
}
const DatePicker = /*#__PURE__*/(0, _react.forwardRef)((_ref3, ref) => {
  let {
    classNameRoot,
    classNameInput,
    classNameItem,
    classNameIcon,
    classNameToggle,
    classNameLockIcon,
    testAttrRoot,
    testAttrItem,
    testAttrToggle,
    testAttrCalendar,
    testAttrError,
    testAttrCloseButton,
    i18nItemLabel,
    i18nChooseLabel,
    i18nCalendarContainerLabel,
    i18nInvalidError,
    i18nClose,
    i18nCloseLabel,
    id,
    label,
    readOnly,
    disabled,
    required,
    error,
    customValidationError,
    name,
    defaultValue,
    value: externalValue,
    showCalendarToggle,
    showCloseButton,
    calendar,
    onShowCalendar,
    onHideCalendar,
    onChange,
    onInvalid,
    isDobInput,
    dobHelpNode
  } = _ref3;
  const _CALENDAR_DEFAULTS$ca = _objectSpread(_objectSpread({}, CALENDAR_DEFAULTS), calendar),
    {
      navigationType
    } = _CALENDAR_DEFAULTS$ca,
    restCalendar = (0, _objectWithoutProperties2.default)(_CALENDAR_DEFAULTS$ca, _excluded);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    format,
    DateTimeFormat
  } = (0, _DateTime.useL10nDateTimeContext)();
  const rootRef = (0, _react.useRef)(null);
  const inputRef = (0, _react.useRef)(null);
  const calendarToggleRef = (0, _react.useRef)(null);
  const calendarContainerRef = (0, _react.useRef)(null);
  const [key, setKey] = (0, _react.useState)((0, _uuid.v4)());
  const [isInputInvalid, setIsInputInvalid] = (0, _react.useState)(Boolean(customValidationError));
  const [showCalendar, setShowCalendar] = (0, _react.useState)(false);
  const [showInvalidError, setShowInvalidError] = (0, _react.useState)(false);
  const [value, setValue] = (0, _react.useState)(defaultValue);
  const [displayValue, setDisplayValue] = (0, _react.useState)();
  const [literal, setLiteral] = (0, _react.useState)(null);
  const [dateFormat, setDateFormat] = (0, _react.useState)(null);
  const [pattern, setPattern] = (0, _react.useState)(null);
  const [screenReaderLabel, setScreenReaderLabel] = (0, _react.useState)(i18nChooseLabel || t('ui:datePicker.chooseDate'));
  const [mask, setMask] = (0, _react.useState)(null);
  const [displayMask, setDisplayMask] = (0, _react.useState)(null);
  const onInputInvalid = validationState => {
    setIsInputInvalid(true);
    if (onInvalid) {
      onInvalid(validationState);
    }
  };
  const onHide = () => {
    setShowCalendar(false);
    if (onHideCalendar) {
      onHideCalendar();
    }

    // re-focus the show calendar button for keyboard users if its showing
    setTimeout(() => {
      var _calendarToggleRef$cu;
      (_calendarToggleRef$cu = calendarToggleRef.current) === null || _calendarToggleRef$cu === void 0 ? void 0 : _calendarToggleRef$cu.focus();
    }, 0);
  };
  const onCalendarToggle = () => {
    if (!showCalendar) {
      setShowCalendar(true);
      if (onShowCalendar) {
        onShowCalendar();
      }
    } else {
      onHide();
    }
  };
  const onInputChange = _ref4 => {
    let {
      target: {
        value: input
      }
    } = _ref4;
    setIsInputInvalid(false);
    setShowInvalidError(false);
    if (input.length === 10) {
      const formatParts = dateFormat.split(literal);
      const yearIndex = formatParts.indexOf(DATE_FORMAT_PARTS.year);
      const monthIndex = formatParts.indexOf(DATE_FORMAT_PARTS.month);
      const dayIndex = formatParts.indexOf(DATE_FORMAT_PARTS.day);
      const dateParts = input.split(literal);
      const year = parseInt(dateParts[yearIndex], 10);
      const month = parseInt(dateParts[monthIndex], 10) - 1;
      const day = parseInt(dateParts[dayIndex], 10);
      const today = new Date().setHours(0, 0, 0, 0);
      const selectedDate = new Date(year, month, day);

      // manually validate month and day because JS new Date accpets out of range months and days
      if (month < 0 || month > 11 || day < 1 || day > 31) {
        return setShowInvalidError(true);
      }

      // Validation for DOB Input
      if (isDobInput && (selectedDate > today || year < 1900)) {
        return setShowInvalidError(true);
      }
      const newValue = format(new Date(year, month, day), SUBMIT_FORMAT);
      setValue(newValue);
      if (onChange) {
        onChange(newValue);
      }

      // re-focus the input after valid entry
      setTimeout(() => {
        var _inputRef$current$que;
        (_inputRef$current$que = inputRef.current.querySelector('input')) === null || _inputRef$current$que === void 0 ? void 0 : _inputRef$current$que.focus();
      }, 0);
    }
  };
  const onCalendarChange = date => {
    setIsInputInvalid(false);
    setShowInvalidError(false);

    /**  Adding a setTimeout fixes an issue with Safari not setting focus
     * back to the button that triggers date picker after selecting a date
     */
    setTimeout(() => {
      onHide();
    }, 0);

    // clicking the already selected day would result in erasing the value
    if (date) {
      setValue(date);
      if (onChange) {
        onChange(date);
      }
    }
  };
  const onCalendarKeyDown = evt => {
    // Pressed ESC key, close the calendar
    if (evt.keyCode === 27) {
      onHide();
    }
  };
  (0, _useOnClickOutside.default)({
    target: rootRef,
    callback: onHide,
    enabled: showCalendar
  });
  (0, _react.useEffect)(() => {
    const {
      literal: newLiteral,
      displayValue: newValue,
      dateFormat: newDateFormat,
      mask: newMask,
      pattern: newPattern,
      displayMask: newDisplayMask
    } = getInfo({
      t,
      DateTimeFormat,
      date: value
    });
    const isMobileDevice = _environment.default.isMobileDevice();
    const srLabelDevice = isMobileDevice ? t('ui:datePicker.chooseDate') : t('ui:datePicker.expandCalendar');
    const srLabel = newValue ? ", ".concat(t('ui:datePicker.selected', {
      date: format(new Date(value), 'EEEE, MMMM d, yyyy')
    })) : '';
    setLiteral(newLiteral);
    setDisplayValue(newValue);
    setDateFormat(newDateFormat);
    setMask(newMask);
    setPattern(newPattern);
    setDisplayMask(newDisplayMask);
    setScreenReaderLabel("".concat(i18nChooseLabel || srLabelDevice).concat(srLabel));
    setKey((0, _uuid.v4)());
    // `t` doesn't change so it doesn't need to be in the array
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [format, DateTimeFormat, value, i18nChooseLabel]);
  (0, _react.useLayoutEffect)(() => {
    if (showCalendar) {
      // focus either the selected day or today, whichever is present
      const {
        current: cal
      } = calendarContainerRef;
      const focusDay = cal.querySelector('button[data-cal-selected]') || cal.querySelector('button[data-cal-today]') || cal.querySelector('button[data-cal-day]');
      if (focusDay) {
        focusDay.focus();
      }

      // Closes the calendar when the ESC key is pressed
      cal.addEventListener('keydown', onCalendarKeyDown);
      return () => {
        cal.removeEventListener('keydown', onCalendarKeyDown);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCalendar]);
  (0, _react.useEffect)(() => {
    setIsInputInvalid(Boolean(customValidationError));
  }, [customValidationError]);
  (0, _react.useEffect)(() => {
    if (externalValue) setValue(externalValue);
  }, [externalValue]);

  // expose external API methods
  (0, _react.useImperativeHandle)(ref, () => ({
    /**
     * Retrieves localized display information about the current date.
     *
     * @public
     * @param {String} date - The date in the format 'MM/dd/yyyy' to retrieve information for.
     * @returns {Object} - The display data about the given date.
     */
    getDisplayInfo: date => getInfo({
      t,
      DateTimeFormat,
      date
    })
  }));
  const onKeydownCloseBtn = e => {
    // if TAB key pressed should focus on the previous month button
    if (e.keyCode === 9 && !e.shiftKey) {
      const prevMonthArrowBtn = document.querySelector('button[data-trap="prevMonthArrowBtn"]');
      const prevMonthDropdownNav = document.querySelector('select[data-trap="prevMonthDropNav"]');
      e.preventDefault();
      if (prevMonthArrowBtn) {
        prevMonthArrowBtn.focus();
      } else if (prevMonthDropdownNav) {
        prevMonthDropdownNav.focus();
      }
    }
  };
  const dobHelper = isDobInput && dobHelpNode;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: rootRef,
    className: (0, _cnbuilder.cnb)(_DatePickerModule.default.root, {
      [_DatePickerModule.default.readOnly]: readOnly
    }, {
      [_DatePickerModule.default.withLockIcon]: readOnly
    }, {
      [_DatePickerModule.default.withToggle]: showCalendarToggle
    }, {
      [_DatePickerModule.default.invalid]: isInputInvalid || showInvalidError
    }, classNameRoot),
    "data-test": testAttrRoot,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      type: "hidden",
      name: name,
      defaultValue: displayValue
    }, "".concat(key, "-value")), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TextInput.default, _objectSpread(_objectSpread(_objectSpread({
      rootAttrs: {
        ref: inputRef
      },
      id: id,
      classNameRoot: classNameInput,
      classNameControl: _DatePickerModule.default.control,
      classNameItemContainer: _DatePickerModule.default.itemContainer,
      classNameItem: (0, _cnbuilder.cnb)(classNameItem, _DatePickerModule.default.item),
      classNameIcon: (0, _cnbuilder.cnb)(_DatePickerModule.default.lock, classNameIcon),
      testAttrItem: testAttrItem,
      testAttrError: testAttrError,
      disabled: disabled,
      readOnly: readOnly,
      value: displayValue,
      label: label,
      i18nItemLabel: i18nItemLabel,
      mask: mask,
      pattern: pattern,
      helpNode: dobHelper ? dobHelpNode : displayMask,
      autoComplete: "off",
      "aria-autocomplete": "none",
      required: required,
      error: error,
      customValidationError: showInvalidError ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormElementError.default, {
        children: i18nInvalidError || t('ui:datePicker.invalid')
      }) : customValidationError
    }, showCalendarToggle && {
      contentAfter: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
        ref: calendarToggleRef,
        className: (0, _cnbuilder.cnb)(_DatePickerModule.default.toggle, classNameToggle),
        testAttr: testAttrToggle,
        i18nLabel: screenReaderLabel,
        disabled: disabled,
        onClick: onCalendarToggle,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_calendarDefault.default, {})
      })
    }), readOnly && !isDobInput && {
      contentAfter: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton.default, {
        className: (0, _cnbuilder.cnb)(_DatePickerModule.default['lock-icon'], classNameLockIcon),
        testAttr: testAttrToggle,
        i18nLabel: screenReaderLabel,
        disabled: readOnly,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_lockDefault.default, {})
      })
    }), {}, {
      onChange: onInputChange,
      onInvalid: onInputInvalid
    }), key), showCalendar && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      ref: calendarContainerRef,
      className: _DatePickerModule.default.calendarContainer,
      "data-test": testAttrCalendar,
      role: "dialog",
      "aria-modal": "true",
      "aria-label": i18nCalendarContainerLabel || t('ui:datePicker.calendarContainerLabel'),
      style: {
        top: calculateCalendarY(inputRef.current)
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Calendar.default, _objectSpread(_objectSpread({}, restCalendar), {}, {
        id: id,
        classNameRoot: (0, _cnbuilder.cnb)(_DatePickerModule.default.calendar, restCalendar.classNameRoot),
        navigationType: navigationType,
        selectedDate: value,
        onChange: onCalendarChange
      })), showCloseButton && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
        className: _DatePickerModule.default.closeButton,
        testAttr: testAttrCloseButton,
        "aria-label": i18nCloseLabel || t('ui:calendar.closeLabel'),
        "data-trap": "calendarCloseBtn",
        onClick: onHide,
        onKeyDown: onKeydownCloseBtn,
        children: i18nClose || t('ui:calendar.close')
      })]
    })]
  });
});
const DatePickerPropTypes = exports.DatePickerPropTypes = {
  /** Additional class(es) to add to the root element. */
  classNameRoot: _propTypes.default.string,
  /** Additional class(es) to add to the underlying input root element. */
  classNameInput: _propTypes.default.string,
  /** Additional class(es) to add to the underlying input item element. */
  classNameItem: _propTypes.default.string,
  /** Additional class(es) to add to the underlying TextInput's icon element. */
  classNameIcon: _propTypes.default.string,
  /** Additional class(es) to add to the calendar toggle button. */
  classNameToggle: _propTypes.default.string,
  /** Additional class(es) to add to the lock icon element. */
  classNameLockIcon: _propTypes.default.string,
  /** The name of the test attribute to associate to the root element. */
  testAttrRoot: _propTypes.default.string,
  /** The name of the test attribute to associate to the input item element. */
  testAttrItem: _propTypes.default.string,
  /** The name of the test attribute to associate to the calendar toggle button. */
  testAttrToggle: _propTypes.default.string,
  /** The name of the test attribute to associate to the calendar container. */
  testAttrCalendar: _propTypes.default.string,
  /** The name of the test attribute to associate to the error element. */
  testAttrError: _propTypes.default.string,
  /** The name of the test attribute to close to the Calendar. */
  testAttrCloseButton: _propTypes.default.string,
  /** A unique ID which is used to identify this element for accessibility purposes on the client as well as the server. */
  id: _propTypes.default.string.isRequired,
  /** A unique name which is used to identify this element. If belonging to a form this is used as the key for serialization and is required. */
  name: _propTypes.default.string,
  /** A custom label (typically a Label component) to display above the input. */
  label: _propTypes.default.element,
  /** The aria-label to apply to the input item. */
  i18nItemLabel: _propTypes.default.string,
  /** The aria-label to apply to the choose date button that toggles up the calendar. This will concatenate with the selected date if one is available. */
  i18nChooseLabel: _propTypes.default.string,
  /** The aria-label to apply to the calendar container element. */
  i18nCalendarContainerLabel: _propTypes.default.string,
  /** The error to show immediately if an invalid date is entered. */
  i18nInvalidError: _propTypes.default.string,
  /** The name of the Close button. */
  i18nClose: _propTypes.default.string,
  /** The aria-label to apply to the Сlose button. */
  i18nCloseLabel: _propTypes.default.string,
  /** The default date in the format 'MM/dd/yyyy' to display in the input when mounted. */
  defaultValue: _propTypes.default.string,
  /** The date in the format 'MM/dd/yyyy' to display in the input. */
  value: _propTypes.default.string,
  /** Whether to show the calendar toggle button. */
  showCalendarToggle: _propTypes.default.bool,
  /** Whether to show Close button. */
  showCloseButton: _propTypes.default.bool,
  /** Whether the DatePicker is disabled or not. */
  disabled: _propTypes.default.bool,
  /** Whether the DatePicker is read-only. */
  readOnly: _propTypes.default.bool,
  /** Whether this field is required during validation. */
  required: _propTypes.default.bool,
  /** A custom validation error (typically a FormElementError component) to display when this component is part of a form and is invalid. */
  error: _propTypes.default.element,
  /** A custom validation error (typically a FormElementError component) to display and override any other possible error passed when this component is part of a form and is invalid. */
  customValidationError: _propTypes.default.element,
  /** The props to pass through to the Calendar component. */
  calendar: _propTypes.default.shape(_Calendar.CalendarPropTypes),
  /** Function to execute when the Calendar shows. */
  onShowCalendar: _propTypes.default.func,
  /** Function to execute when the Calendar hides. */
  onHideCalendar: _propTypes.default.func,
  /**
   * Function to execute when the selected date changes.
   *
   * @param {String} selectedDate - The selected date in the format 'MM/dd/yyyy'.
   */
  onChange: _propTypes.default.func,
  /**
   * Function to execute when the element is marked as invalid by a validation check.
   *
   * @param {ValidityState} validationState - ValidityState object for more fine grained control over error handling in a parent component if desired.
   */
  onInvalid: _propTypes.default.func,
  /** Boolean to indicate if the DatePicker is being rendered by DOBInput. */
  isDobInput: _propTypes.default.bool,
  /** A custom help node to place above the input. */
  dobHelpNode: _propTypes.default.node
};
DatePicker.defaultProps = {
  testAttrRoot: 'date-picker-root',
  testAttrItem: 'date-picker-item',
  testAttrToggle: 'date-picker-toggle',
  testAttrCalendar: 'date-picker-calendar',
  testAttrError: 'date-picker-error',
  testAttrCloseButton: 'date-picker-close-button',
  showCalendarToggle: true,
  showCloseButton: true,
  calendar: CALENDAR_DEFAULTS,
  isDobInput: false,
  readOnly: false
};
var _default = exports.default = DatePicker;